<script setup lang="ts">
import { ref, toRef, watch } from 'vue';
import type { Emits, Props } from './types';
import TopInput from '@/components/forms/input/input.vue';
import TopButton from '@/components/forms/button/button.vue';

const props = defineProps<Props>();

const intermediateValue = ref(props.modelValue);

watch(toRef(props.modelValue), () => {
	intermediateValue.value = props.modelValue;
});

const emit = defineEmits<Emits>();

const submit = () => {
	emit('update:modelValue', intermediateValue.value);
};
</script>

<template>
	<div class="top-editInput">
		<TopInput
			:="input"
			@keydown.esc.capture.stop="intermediateValue = modelValue"
			@keydown.enter.stop="submit"
			v-model="intermediateValue"
		/>

		<TopButton
			v-if="intermediateValue !== modelValue"
			icon=""
			styling="soft"
			:="button"
			@click="submit"
		/>
	</div>
</template>

<style>
.top-editInput {
	width: 220px;
	flex-grow: 1;
	display: flex;
	align-items: flex-end;
	gap: var(--top-gap-1);
}

.top-editInput .top-input {
	width: unset;
	flex-grow: 1;
}
</style>
